var n = /* @__PURE__ */ new Set([
  "$self",
  "$parent",
  "$root"
]), t = /* @__PURE__ */ (function(r) {
  return r.Once = "Once", r.Loop = "Loop", r.PingPong = "PingPong", r.ClampForever = "ClampForever", r;
})({}), o = /* @__PURE__ */ (function(r) {
  return r.Horizontal = "Horizontal", r.Vertical = "Vertical", r;
})({}), e = /* @__PURE__ */ (function(r) {
  return r.Horizontal = "Horizontal", r.Vertical = "Vertical", r.Free = "Free", r;
})({});
function l(r, a) {
  return r === e.Vertical ? 0 : r === e.Horizontal ? -Math.PI / 2 : (a ?? 0) * Math.PI / 180;
}
export {
  l as a,
  t as i,
  o as n,
  n as r,
  e as t
};

//# sourceMappingURL=common-Cd7R8f1s.js.map